import type { ComponentType } from 'react'
import {
  AnalyticsIcon,
  BillingIcon,
  BranchIcon,
  BroadcastsIcon,
  BrandingIcon,
  CustomersIcon,
  DashboardIcon,
  LogsIcon,
  PosterIcon,
  ProgramsIcon,
  ReferralIcon,
  SecretMenuIcon,
  StaffIcon,
  StampIcon,
  SupportIcon,
} from './components/icons.js'

/**
 * Owner nav model — shared by the bottom-nav (narrow viewport) and the
 * sidebar (≥768px). 4a-1 ships two active routes; everything else renders
 * disabled with a "Coming soon" treatment (4a-2 / 4b). Disabled items don't
 * navigate — tapping shows a sonner toast (see OwnerShell).
 */
export interface NavItem {
  key: string
  label: string
  icon: ComponentType<{ className?: string }>
  /** Route path when active; undefined for disabled "Coming soon" items. */
  to?: string
  /** Primary destinations appear in the bottom-nav; the rest go in the sheet. */
  primary: boolean
}

export const NAV_ITEMS: NavItem[] = [
  { key: 'dashboard', label: 'Dashboard', icon: DashboardIcon, to: '/dashboard', primary: true },
  { key: 'stamp', label: 'Stamp', icon: StampIcon, to: '/owner/stamp', primary: true },
  { key: 'broadcasts', label: 'Broadcasts', icon: BroadcastsIcon, to: '/owner/broadcasts', primary: true },
  { key: 'analytics', label: 'Analytics', icon: AnalyticsIcon, to: '/owner/analytics', primary: false },
  { key: 'programs', label: 'Program', icon: ProgramsIcon, to: '/owner/program', primary: false },
  { key: 'referrals', label: 'Referrals', icon: ReferralIcon, to: '/owner/referrals', primary: false },
  { key: 'secret-menu', label: 'Secret Menu', icon: SecretMenuIcon, to: '/owner/secret-menu', primary: false },
  { key: 'branding', label: 'Branding', icon: BrandingIcon, to: '/branding', primary: false },
  { key: 'poster', label: 'In-store poster', icon: PosterIcon, to: '/owner/poster', primary: false },
  { key: 'branches', label: 'Branches', icon: BranchIcon, to: '/owner/branches', primary: false },
  { key: 'staff', label: 'Staff', icon: StaffIcon, to: '/owner/staff', primary: false },
  { key: 'logs', label: 'Logs', icon: LogsIcon, to: '/owner/logs', primary: false },
  { key: 'customers', label: 'Customers', icon: CustomersIcon, to: '/owner/customers', primary: false },
  { key: 'support', label: 'Contact support', icon: SupportIcon, to: '/owner/support', primary: false },
  { key: 'billing', label: 'Billing', icon: BillingIcon, primary: false },
]
